import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-text-small',
    templateUrl: './text-small.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextSmallComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
